import type { OptimizerAuditV2Record } from '../../types/audit.types';
import type { WeightDiffDetailRow } from '../../types/snapshot.types';
import { summarizePortfolioAudit } from '../audit/portfolioAuditSummary';

export type TradeActivitySummary = {
  totalBuyCents: number;
  totalSellCents: number;
  tradeCount: number;
  exits: WeightDiffDetailRow[];
  entries: WeightDiffDetailRow[];
};

export const buildTradeActivitySummary = (
  diffRows: WeightDiffDetailRow[],
  audit?: OptimizerAuditV2Record,
): TradeActivitySummary | null => {
  if (diffRows.length === 0) {
    return null;
  }

  const auditSummary = summarizePortfolioAudit(audit);

  return {
    totalBuyCents:
      auditSummary?.totalBuyCents ??
      diffRows
        .filter((row) => row.deltaCents > 0)
        .reduce((sum, row) => sum + row.deltaCents, 0),
    totalSellCents:
      auditSummary?.totalSellCents ??
      diffRows
        .filter((row) => row.deltaCents < 0)
        .reduce((sum, row) => sum + Math.abs(row.deltaCents), 0),
    tradeCount: auditSummary?.tradeCount ?? 0,
    exits: diffRows.filter(
      (row) => row.proposedCents === 0 && row.currentCents > 0,
    ),
    entries: diffRows.filter(
      (row) => row.currentCents === 0 && row.proposedCents > 0,
    ),
  };
};
